var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsheets2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1 71.8601C66.1 74.1641 64.174 76.0001 61.834 76.0001H17.266C14.908 76.0001 13 74.1281 13 71.8601V8.17613C13 5.87213 14.926 4.03613 17.266 4.03613H45.922L66.1 24.1601V71.8601Z",
    fill: "#22A466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.136 23.6562L66.1 40.3603L66.046 24.1423L48.136 23.6562Z",
    fill: "#1A8E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1 24.142H50.152C47.794 24.142 45.886 22.27 45.886 20.002V4L66.1 24.142Z",
    fill: "#8ECEAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.26 59.3499V55.7499H49.936V59.3499H41.26ZM29.128 55.7499H37.804V59.3499H29.128V55.7499ZM37.84 53.2659H29.164V49.3779H37.84V53.2659ZM37.84 42.7359V46.8759H29.164V42.7359H37.84ZM41.26 49.3959H49.936V53.2659H41.26V49.3959ZM49.936 46.8759H41.26V42.7359H49.936V46.8759ZM25.744 39.3879V62.7159H53.392V39.3879H25.744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsheets2);
export default __webpack_public_path__ + "static/media/gsheets 2.baff408c1c1a8282fe2effc418f250ad.svg";
export { ForwardRef as ReactComponent };